<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <v-card class="mb-8">
          <v-toolbar flat color="primary" dark>
            <v-toolbar-title>Overall</v-toolbar-title>
          </v-toolbar>
          <div class="pa-4 subtitle-2" style="color:grey">
            CURRENT STATUS:
            <span
              :style="`color: ${getStatusColor(
                paper.state.status
              )}; font-weight: 400`"
            >
              {{ paper.state.status }}</span
            >
          </div>
          <div class="pa-4 subtitle-2" style="color:grey">
            LAST UPDATE:
            <span style="color:black"> {{ paper.lastUpdate }}</span>
          </div>
          <div
            v-if="needUpload(paper.state.status)"
            class="pa-4 subtitle-2"
            style="color: red"
          >
            Please re-upload your paper following the suggested revisions
          </div>
        </v-card>
        <v-card class="pb-2">
          <v-toolbar flat color="primary" dark>
            <v-toolbar-title>Revision Comments</v-toolbar-title>
          </v-toolbar>
          <div class="ma-4">
            <div v-if="reviews.length == 0" class="grey--text">
              No Comments
            </div>
            <div v-for="(review, i) in reviews" :key="i">
              <div v-if="review.review.length">
                <v-row align="center" justify="space-between" class="mx-5">
                  <v-row align="center" class="ma-0">
                    <v-avatar>
                      <v-icon x-large color="black">{{
                        icon.mdiAccountCircle
                      }}</v-icon>
                    </v-avatar>

                    <div style="font-weight: 600; font-size: 120%" class="ml-3">
                      Reviewer {{ i + 1 }}
                    </div>
                  </v-row>
                  <v-col align="center" cols="12" lg="2" md="2" sm="4" xs="4">
                    <div class="caption">{{ review.revisionDate }}</div>
                    <div
                      :style="`color: ${getStatusColor(
                        review.status
                      )}; font-weight: 400`"
                    >
                      {{ review.status }}
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mx-7 my-2">
                  <div>{{ review.review }}</div>
                </v-row>
                <v-divider />
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiAccountCircle } from "@mdi/js";
import paperStatus from "@/helpers/paperStatus.js";

export default {
  props: ["paper"],
  data: () => ({
    icon: {
      mdiAccountCircle,
    },
  }),
  methods: {
    getStatusColor(status) {
      return paperStatus.getStatusColor(status);
    },
    needUpload(status) {
      return paperStatus.needsReupload(status);
    },
  },
  computed: {
    reviews() {
      if (this.paper.state) return Object.values(this.paper.state.reviews);

      return [];
    },
  },
};
</script>